// @flow
import React, {type Node} from 'react';
import styled from 'styled-components';
import {DropdownArrow} from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-arrow';
import type { DropdownOption } from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-option';

type Props = {|
  selectedOption: DropdownOption,
  isOpen: boolean,
  setIsOpen: (boolean) => void,
  defaultText: string,
  disabled: boolean,
|}

export default function DropdownButton({selectedOption , isOpen, setIsOpen, defaultText, disabled}: Props): Node {
  const handleClick = () => {
    if (!disabled) setIsOpen(!isOpen);
  };

  return (
    <Wrapper onClick={handleClick} isOpen={isOpen} disabled={disabled}>
      {selectedOption?.icon && selectedOption.icon}
      <Text hasSelectedOption={selectedOption}>
        {selectedOption?.text || defaultText}
      </Text>
      <DropdownArrow isOpen={isOpen}/>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  padding: 16px;
  gap: 8px;
  border-radius: ${props => (props.isOpen ? '4px 4px 0px 0px' : '4px')};
  background-color: ${props => (props.disabled) ? props.theme.colors.neutral[100] : props.theme.colors.white};

  cursor: ${props => (props.disabled) ? 'not-allowed' : 'pointer'};
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
  transition: box-shadow 0.2s ease-in-out;
  display: flex;
  align-self: stretch;
  align-items: center;
  text-wrap: nowrap;
`;

const Text = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  color: ${props => props.hasSelectedOption ? props.theme.colors.black :'#919EAB'};

  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
`;
